module.exports = __webpack_public_path__ + "media/eyezen-boost_smartphone.680a3840.mp4";